module.exports = __webpack_public_path__ + "img/cel.013e83f5.png";